import React from 'react';
import PageTemplate from '../PageTemplate';

const Vision = () => {
  return (
    <PageTemplate
      title="🎯 설립취지 및 비전"
      description="청소년 스마트폰 프리 운동본부의 설립 배경과 비전을 소개합니다"
    >
      <div>
        <h2>🌟 설립취지</h2>
        <br />
        <p>
          현대 사회에서 스마트폰은 필수적인 도구가 되었지만, 청소년들의 과도한 사용으로 인한 
          부작용이 심각한 사회 문제로 대두되고 있습니다.
        </p>
        <br />
        <ul style={{ paddingLeft: '2rem', lineHeight: '1.8' }}>
          <li><strong>학습 능력 저하:</strong> 집중력 부족과 학업 성취도 하락</li>
          <li><strong>사회성 결여:</strong> 대면 소통 능력 감소와 인간관계 문제</li>
          <li><strong>신체 건강 악화:</strong> 거북목, 안구건조증, 수면 장애 등</li>
          <li><strong>정신 건강 문제:</strong> 우울감, 불안감, 중독 증상 등</li>
        </ul>
        <br />
        <p>
          이러한 문제들을 해결하고 건강한 디지털 문화를 조성하기 위해 
          청소년 스마트폰 프리 운동본부가 설립되었습니다.
        </p>
        
        <br /><br />
        
        <h2>🚀 비전</h2>
        <br />
        <div style={{ background: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem' }}>
          <h3 style={{ color: '#e74c3c', textAlign: 'center', marginBottom: '1rem' }}>
            "스마트폰과 조화롭게 공존하는 건강한 디지털 사회"
          </h3>
        </div>
        
        <h3>📋 주요 목표</h3>
        <br />
        <ol style={{ paddingLeft: '2rem', lineHeight: '1.8' }}>
          <li>
            <strong>인식 개선:</strong> 스마트폰 과의존의 심각성에 대한 사회적 인식 제고
          </li>
          <li>
            <strong>교육 확산:</strong> 올바른 스마트폰 사용법에 대한 체계적 교육 프로그램 운영
          </li>
          <li>
            <strong>정책 제안:</strong> 건전한 디지털 환경 조성을 위한 정책 연구 및 제안
          </li>
          <li>
            <strong>문화 조성:</strong> 스마트폰 프리 문화 확산을 통한 사회 분위기 개선
          </li>
          <li>
            <strong>지원 체계:</strong> 청소년과 가족을 위한 상담 및 지원 서비스 제공
          </li>
        </ol>
        
        <br /><br />
        
        <h2>💡 핵심 가치</h2>
        <br />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
          <div style={{ background: '#fff5f5', padding: '1rem', borderRadius: '8px', border: '1px solid #fed7d7' }}>
            <h4 style={{ color: '#e74c3c', marginBottom: '0.5rem' }}>🎯 균형</h4>
            <p>디지털 기술과 아날로그 생활의 조화로운 균형</p>
          </div>
          <div style={{ background: '#f0fff4', padding: '1rem', borderRadius: '8px', border: '1px solid #9ae6b4' }}>
            <h4 style={{ color: '#28a745', marginBottom: '0.5rem' }}>🤝 소통</h4>
            <p>진정한 인간관계와 대면 소통의 가치 회복</p>
          </div>
          <div style={{ background: '#f7fafc', padding: '1rem', borderRadius: '8px', border: '1px solid #cbd5e0' }}>
            <h4 style={{ color: '#2d3748', marginBottom: '0.5rem' }}>🌱 성장</h4>
            <p>건강한 디지털 시민으로서의 성장과 발전</p>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Vision; 